import type { ColumnsType } from "antd/es/table";

import { EARLY_PAYOUT_REPORTING_TABLE_LABELS } from "./earlyPayoutReportingConstants";
import { formatBetCount, formatPayout } from "./earlyPayoutReportingUtils";
import type { EarlyPayoutReportingRow } from "./earlyPayoutTypes";

export const EARLY_PAYOUT_REPORTING_COLUMNS: ColumnsType<EarlyPayoutReportingRow> =
  [
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.sport,
      dataIndex: "sport",
      key: "sport",
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.league,
      dataIndex: "league",
      key: "league",
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.market,
      dataIndex: "market",
      key: "market",
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.matchup,
      dataIndex: "matchup",
      key: "matchup",
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.timeOfWin,
      dataIndex: "timeOfWin",
      key: "timeOfWin",
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.scoreOnWin,
      dataIndex: "scoreOnWin",
      key: "scoreOnWin",
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.numberOfBets,
      key: "numberOfBets",
      render: (_, row) => formatBetCount(row.numberOfBets),
    },
    {
      title: EARLY_PAYOUT_REPORTING_TABLE_LABELS.settledPayout,
      key: "settledPayout",
      render: (_, row) => formatPayout(row.settledPayout),
    },
  ];
